<div class="close-div">
  <button mat-stroked-button (click)="minimiseSheet()">
    <div class="arrow"></div>
  </button>
</div>
